import { Button, makeStyles, TextField, IconButton, Typography, Toolbar, AppBar } from '@material-ui/core';
import { DatePicker, LocalizationProvider, StaticDatePicker } from '@material-ui/pickers';
import React, { useEffect, useMemo, useState } from 'react';
import MomentUtils from '@material-ui/pickers/adapter/moment';
import moment from "moment-timezone"
import { EditOutlined } from '@material-ui/icons';

export const useStyles = makeStyles({
  toolbar: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    alignContent: "center",
  },
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
  },
  date: {
    display: "flex",
    flexDirection: "row",
    cursor: "pointer",
  }
});

const CustomToolbar = function (props) {
  const { date,
    isLandscape,
    openView,
    setOpenView,
    title = 'title' } = props;

  const handleChangeViewClick = (view) => (e) => {

    setOpenView(view);

  }

  const classes = useStyles();

  return (
    <AppBar color="inherit" position="relative"
      elevation={0}>
      <Toolbar
        className={classes.toolbar}
        toolbarTitle={title}
        disableGutters
      >
        <div className={classes.root}>
          <Typography variant="h6" color="inherit">{props?.toolbarTitle}</Typography>
          <div className={classes.date}>
            <Typography
              onClick={handleChangeViewClick("date")}
              variant="h5"
              selected={openView === "date"}
            >
              {date.format("ddd\xa0")}
            </Typography>
            <Typography
              onClick={handleChangeViewClick("month")}
              variant="h5"
              selected={openView === "month"}
            >
              {date.format("MMM\xa0")}
            </Typography>

            <Typography
              onClick={handleChangeViewClick("date")}
              variant="h5"
              selected={openView === "date"}
            >
              {date.format("DD,\xa0")}
            </Typography>
            <Typography
              onClick={handleChangeViewClick("year")}
              variant="h5"
              selected={openView === "year"}
            >
              {date.format("YYYY")}
            </Typography>

          </div>
        </div>

        <IconButton onClick={() => props.toggleMobileKeyboardView()}><EditOutlined /></IconButton>
      </Toolbar>
    </AppBar>
  );
}

const StaticPicker = ({ label, value, onChange }) => {
  const classes = useStyles()
  return (
    <StaticDatePicker
      ToolbarComponent={(props) => <CustomToolbar
        {...props}
        toolbarTitle={label}
      />}
      displayStaticWrapperAs='mobile'
      openTo="date"
      minDate={new Date()}
      maxDate={moment().add(1, 'y').toDate()}
      // disablePast
      value={value}
      onChange={(newValue) => onChange(newValue)}
      renderInput={(props) => <TextField variant="outlined"  {...props} />}
    />
  )
}

const WrapPicker = props => {
  //NOTE: Use this pattern to set the filters beforehand to prevent unecessary rerendering
  // const [state, dispatch] = useReducer(dataGridReducer, { ...initState, filterColumn: { partner: '', statuses: '' } });
  return (
    <LocalizationProvider dateAdapter={MomentUtils}>
      <DatePicker
        shouldDisableDate={(date) => {
          if(props?.noPast) {
            const minDate = props.minLimit || moment().startOf('day')
            return date?.isBefore(minDate)
          }
          return false
        }}
        renderInput={(props) => <TextField
          size="small" fullWidth variant="outlined"  {...props} />}
        {...props}
      />
    </LocalizationProvider>
  );
};

const WrapStaticPicker = props => {
  //NOTE: Use this pattern to set the filters beforehand to prevent unecessary rerendering
  // const [state, dispatch] = useReducer(                                                                                                                                                     Reducer, { ...initState, filterColumn: { partner: '', statuses: '' } });
  return (
    <LocalizationProvider dateAdapter={MomentUtils}>
      <StaticPicker {...props} />
    </LocalizationProvider>
  );
};
export { WrapStaticPicker as StaticCalendar, WrapPicker as DatePicker };